import { Component, OnInit, OnDestroy } from '@angular/core';
import { Constant } from '../environments/constants';
import { User } from './services/models';
import { UserService } from './services/context/user.service';
import { ThemeService } from './services/util/theme.service';

import { AppMonitoringService } from './services/util/app-monitoring.service';
import { Subscription } from 'rxjs';
import { Logger, CryptoUtils, AuthenticationParameters } from 'msal';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { FormControl, Validators } from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';
import { ContextDebugComponent } from '../app/context-components/context-debug/context-debug.component';


import { ContextService } from './services/context/context.service';
import { DataService } from './services/context/data.service';
import { RefDataService } from './services/context/ref-data.service';
import { UIStateService } from './services/context/uistate.service';
import { ReferenceService } from './services/reference/reference.service';
import * as fromModel from './services/models/';




@Component({
  selector: 'gp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'GPT';
  jwtHelperSvc: JwtHelperService; //to decode JSON Token to Javascript object
  userName = '';
  userEmailId = '';
  //isIframe: boolean;
  loggedIn = false;
  private subscription: Subscription;

  appName = "GOALS PLANNING";
  isSuperUser = true;
  txtRepId = new FormControl('', [Validators.maxLength(30)]);

  constructor(
    private broadcastService: BroadcastService,
    private authService: MsalService,
    private userService: UserService,
    private themeService: ThemeService,   
    private contextService: ContextService,
    private dataService: DataService,
    private refDataService: RefDataService,
    private referenceService: ReferenceService,
    private uiStateService: UIStateService,   
    private dialog: MatDialog,
    private appMonitoringService: AppMonitoringService) {       
  }

  ngOnInit() {
  
    //this.isIframe = window !== window.parent && !window.opener;  
    this.themeService.setLightTheme();
    //this.themeService.setDarkTheme();
    this.checkoutAccount();
      if (!this.loggedIn) {
      this.login();
    } else {
      this.getUserName();
    }
  
    this.subscription = this.broadcastService.subscribe("msal:acquireTokenFailure", (payload) => {
     console.log('Error: Acquire Token Failure: ' + payload);
     this.appMonitoringService.traceMsg("Error: Acquire Token Failure:  " + this.userName, payload, 'Error');
     this.authService.loginRedirect();
    });
  
    this.broadcastService.subscribe('msal:loginSuccess', (payload) => {
      this.checkoutAccount();
      this.getUserName();
      this.appMonitoringService.traceMsg("Successful login for: " + this.userName, payload, 'Information');
    });
  
    this.broadcastService.subscribe('msal:loginFailure', (payload) => {
      console.log('Login failure');
      this.appMonitoringService.traceMsg('Login Failed.', payload, 'Error');
      this.loggedIn = false;      
    });
  
    
    this.authService.handleRedirectCallback((authError, response) => {
      if (authError) {
        console.error('Redirect Error: ', authError.errorMessage);
        this.appMonitoringService.traceMsg('Redirect Error: ', authError.errorMessage, 'Error');
        this.appMonitoringService.traceMsg("Redirect Success: " + response, 'Information');
        return;
      }
      console.log('Redirect Success: ', response);
    });
  
    this.authService.setLogger(new Logger((logLevel, message, piiEnabled) => {
      console.log('MSAL Logging: ', message);
    }, {
      correlationId: CryptoUtils.createNewGuid(),
      piiLoggingEnabled: false
    }));
  
    //reference services call
    // this.dataService.getIndustrySectorReferenceData();
    // this.dataService.getBenchmarkRefData();
    // this.dataService.getTaxonomyReferenceData();   

    this.gptReset();
  }
  
  login() {
    this.authService.acquireTokenSilent({ scopes: Constant.config.scopes } as AuthenticationParameters);  
  }
  
  logout() {
    this.authService.logout();
  }
  
  private checkoutAccount() {
    this.loggedIn = !!this.authService.getAccount();
  }

  private getUserName() {

    let user: User;

    if (!this.jwtHelperSvc) {
      this.jwtHelperSvc = new JwtHelperService();
    }
    const decodedToken = this.jwtHelperSvc.decodeToken(localStorage.getItem('msal.idtoken'));

    if(decodedToken){
      if(decodedToken.name) {
        this.userName = decodedToken.name;
      }

      if(decodedToken.preferred_username){
        this.userEmailId = decodedToken.preferred_username;
      }
    }

    let _repIds = [];
    if(decodedToken.primaryid){
      _repIds.push(decodedToken.primaryid);
    }
    if(decodedToken.poolIds){
      (decodedToken.poolIds.split(',') as any[]).forEach(i => _repIds.push(i));
    }
    
    user = {repIds: _repIds, primaryUserName: this.userName, primaryEmail: this.userEmailId};
    this.userService.setUser(user);
    this.appMonitoringService.setUser(user);
    this.appMonitoringService.traceMsg('User Details: ', user, 'Information');
    console.log("User Details: " + JSON.stringify(user));  

    if(_repIds.length){
      this.appMonitoringService.traceMsg('Both Rep Id and Pool Ids found for logged in user.', decodedToken, 'Information');
    } else {
      this.appMonitoringService.traceMsg('PoolIds or Rep Id not found in claims', decodedToken, 'Information');
    }
  }

  
  setRepId() {
 
    if (!this.txtRepId.invalid && this.txtRepId.value) {
      var _repIds = this.txtRepId.value.toString().split(",");      
      //this.userService.setRepIds(_repIds);        
    }
  }

  handle(e){
    if(e.keyCode === 13){
        e.preventDefault();
        this.setRepId();
    }
  }

  onToggleTheme() {
    if(this.themeService.isDarkTheme()) {
      this.themeService.setLightTheme();
    } else {
      this.themeService.setDarkTheme();
    }    
  }

  ngOnDestroy(): void { 
    this.appMonitoringService.flushMessages();
    this.broadcastService.getMSALSubject().next(1);
    if (this.subscription && this.subscription !== null) {
      this.subscription.unsubscribe();
    }
  }

  openModelDialog(action: string, documentType?: string){
    switch(action){
      
      default: {
        const dialogRef = this.dialog.open(ContextDebugComponent, {
          width: '90%',
          height: '90%'      
        });
        break;
      }
    }
  }

  gptReset(){
    // this.contextService.dispatchAction(fromModel.APP_ACTION.RESET, "AppComponent - gptReset", null);
    // this.dataService.dispatchAction(fromModel.DATA_ACTION.RESET, "AppComponent - gptReset", null);
    // this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.RESET, "AppComponent - gptReset", null);
    // this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.RESET, "AppComponent - gptReset", null); 
    this.referenceService.getKeyValueReferenceData();
    this.referenceService.getLifeExpectancyReferenceData();
    this.referenceService.getAccountReferenceData();
    this.referenceService.getPlanningUIRefrenceData();
  }
}
